var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-dropzone" }, [
    _c(
      "div",
      {
        staticClass: "c-dropzone__container",
        style: _vm.isDragging && "border-color: green;",
        on: {
          dragover: _vm.dragover,
          dragleave: _vm.dragleave,
          drop: _vm.drop,
        },
      },
      [
        _c("input", {
          ref: "file",
          staticClass: "c-dropzone__hidden-input",
          attrs: {
            type: "file",
            multiple: "",
            name: "file",
            id: "fileInput",
            accept: ".pdf,.jpg,.jpeg,.png,.docx,.xls",
          },
          on: { change: _vm.onChange },
        }),
        _vm._v(" "),
        _vm.errorText
          ? _c("p", { staticClass: "is-error" }, [
              _vm._v("\n          " + _vm._s(_vm.errorText) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "c-dropzone__file-label",
            attrs: { for: "fileInput" },
          },
          [
            _vm.isDragging
              ? _c(
                  "div",
                  { staticClass: "c-dropzone__file-label-releasetext" },
                  [_vm._v(_vm._s(_vm.$t("internalfiles.releasefileshere")))]
                )
              : _c("div", { staticClass: "c-dropzone__file-label-droptext" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("internalfiles.dropfileshere")) +
                      "\n      "
                  ),
                ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _c("button", { staticClass: "button", on: { click: _vm.uploadFiles } }, [
        _vm._v(" " + _vm._s(_vm.$t("internalfiles.clicktoupload"))),
      ]),
    ]),
    _vm._v(" "),
    _vm.files.length
      ? _c(
          "div",
          { staticClass: "c-dropzone__preview-container" },
          _vm._l(_vm.files, function (file) {
            return _c(
              "div",
              {
                key: file.name,
                staticClass: "c-dropzone__preview-card",
                class: file.classname,
              },
              [
                file.error
                  ? _c("span", [_vm._v(_vm._s(file.error))])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "c-dropzone__filename" }, [
                  _vm._v("\n            " + _vm._s(file.name) + " "),
                  _c("br"),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(Math.round(file.size / 1000) + " KB")),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    attrs: { type: "button", title: "Remove file" },
                    on: {
                      click: function ($event) {
                        _vm.remove(_vm.files.indexOf(file))
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("x"),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }